/* eslint-disable @typescript-eslint/no-unused-vars */
import { billing } from "store/requests";
import { downloadFile } from "utils/helper";
import { showSnackbar } from "./appActions";

export const getBillingBatchList = async (payload) => {
  try {
    let { data } = await billing({
      url: "/getBillingBatchList",
      payload,
    });
    return data;
  } catch (error) {
    console.log("error getBillingBatchList: ", error);
  }
};

export const pendingBillReport = async (payload) => {
  try {
    let { data } = await billing({
      url: "/requestBillingCycle",
      payload,
    });
    return data;
  } catch (error) {
    console.log("error pendingBillReport: ", error);
  }
};

export const getWebVersion = async (payload) => {
  try {
    let { data } = await billing({
      url: "/getWebVersion",
      payload,
    });
    return data;
  } catch (error) {
    console.log("error getWebVersion: ", error);
  }
};

export const getBillingDetails = async (payload) => {
  try {
    let { data } = await billing({
      url: "/getBillingDetails",
      payload,
    });
    return data;
  } catch (error) {
    console.log("error getBillingDetails: ", error);
  }
};

export const getMonthlyPayerPaymentSummary = async (payload) => {
  try {
    let { data } = await billing({
      url: "/getMonthlyPayerPaymentSummary",
      payload,
    });
    return data;
  } catch (error) {
    console.log("error getMonthlyPayerPaymentSummary: ", error);
  }
};

export const getBillInvoices = async (payload) => {
  try {
    let { data } = await billing({
      url: "/getBillInvoices",
      payload,
    });
    return data;
  } catch (error) {
    console.log("error getBillInvoices: ", error);
  }
};

export const getBillInvoiceDetails = async (payload) => {
  try {
    let { data } = await billing({
      url: "/getBillInvoiceDetails",
      payload,
    });
    return data;
  } catch (error) {
    console.log("error getBillInvoiceDetails: ", error);
  }
};

export const processBillInvoice = async (payload) => {
  try {
    let { data } = await billing({
      url: "/processBillInvoice",
      payload,
    });
    return data;
  } catch (error) {
    console.log("error processBillInvoice: ", error);
    return error;
  }
};

export const aiAgent = async (payload) => {
  try {
    let { data } = await billing({
      url: "ai/agent",
      payload,
    });
    return data;
  } catch (error) {
    console.log("error aiAgent: ", error);
  }
};

export const getPatientBillReport = () => async (dispatch) => {
  try {
    dispatch(showSnackbar("Intialized downloading patient bill.."));
    let response = await billing({
      url: "/getPatientBillReport",
      payload: {},
      data: { responseType: "blob" },
    });
    downloadFile({ response, filename: "Bill_Report.xlsx" });
  } catch (error) {
    dispatch(showSnackbar("Failed to download patient bill"));
  }
};

export const getClaimStatusReport = () => async (dispatch, payload) => {
  try {
    dispatch(showSnackbar("Intialized downloading patient bill.."));
    let response = await billing({
      url: "/getClaimStatusReport",
      payload,
      data: { responseType: "blob" },
    });
    downloadFile({ response, filename: "Bill_Report.xlsx" });
  } catch (error) {
    dispatch(showSnackbar("Failed to download patient bill"));
  }
};

export const claimSubmitRejectDateInfo = (payload) => async (dispatch) => {
  try {
    dispatch(
      showSnackbar("initiated request and report will be downloaded when ready")
    );
    let response = await billing({
      url: "/claimSubmitRejectDateInfo",
      payload,
      data: { responseType: "blob" },
    });
    downloadFile({ response, filename: "Bill_Report.xlsx" });
  } catch (error) {
    dispatch(showSnackbar("No data found for the given criteria"));
  }
};

export const getPaymentTrxReport = (payload) => async (dispatch) => {
  try {
    dispatch(showSnackbar("Intialized downloading patient bill.."));
    let response = await billing({
      url: "/getPaymentTrxReport",
      payload,
      data: { responseType: "blob" },
    });
    downloadFile({ response, filename: "Bill_Report.xlsx" });
  } catch (error) {
    dispatch(showSnackbar("No data found for the given criteria"));
  }
};
